import Vue                     from 'vue'
import Router                  from 'vue-router'
import store                   from '../store'
import axios                   from 'axios'
import VueAxios                from 'vue-axios'
import adminView               from '@/components/Admin_View'
import infiniteScroll          from 'vue-infinite-scroll'
import vacacionesView          from '@/components/Vacaciones_View'
import boletinesMensualesView  from '@/components/Boletines_Mensuales_View'
import vacacionesEquipoView    from '@/components/View_Vacaciones_Equipo'
import vacacionesExcepcionView from '@/components/View_Vacaciones_Excepcion'
import vacacionesReportesView  from '@/components/View_Vacaciones_Reporte'
import misFuncionesView        from '@/components/View_Mis_Funciones'
import misDatosView            from '@/components/View_Mis_Datos'

import misBoletasView from '@/components/View_Mis_Boletas'
import boletasTransferidasView from '@/components/View_Boletas_Transferidas'
import boletasReporteView from '@/components/View_Boletas_Reporte'
import ViewBoletasCargaManual from '@/views/View_Boletas_Carga_Manual'
import boletasPendientesGenerarView from '@/components/View_Boletas_Pendientes_Generar'
import misPermisosView from '@/components/View_Permisos_Mis_Permisos'
import permisosEquipoView from '@/components/View_Permisos_Mi_Equipo'
import permisosExcepcionView from '@/components/View_Permisos_Excepcion'
import permisosPorAprobarRRHHView from '@/components/View_Permisos_Por_Aprobar_RRHH'
import permisosReportesView from '@/components/View_Permisos_Reporte'

import contratosEquipoView from '@/components/View_Contratos_Equipo'
import contratosGestionView from '@/components/View_Contratos_Gestion'
import ViewContratosCargaManual from '@/views/View_Contratos_Carga_Manual'

import ViewGestionEmpleados from '@/views/View_Gestion_Empleado'
import ViewGestionDocumentosImportantes from '@/views/View_Gestion_Documentos_Importantes'
import ViewDocumentosImportantes from '@/views/View_Documentos_Importantes'

import ViewBoletasTipo from '@/views/View_Gestion_Boletas_Tipo'

import ViewGestionLinksImportantes from '@/views/View_Gestion_Links_Importantes'
import ViewLinksImportantes from '@/views/View_Links_Importantes'

import ViewAuditoria  from '@/views/View_Auditoria'
import ViewHorasExtras from '@/views/View_Horas_Extras'
import ViewReporteVacaciones from '@/views/View_Reporte_Vacaciones'

import ComponentGestionDelegaciones from '@/components/Component_Gestion_Delegaciones_RRHH'
import ComponentAsignarDelegaciones from '@/components/Component_Asignar_Delegaciones'

import ComponentAdministradorFunciones from '@/components/Component_Administrador_Funciones'
import ViewCumpleanios from '@/components/View_Cumpleanios'
import ViewComponentGestionAreas from '@/components/View_Component_Gestion_Areas'
import ViewComponentGestionGerencias from '@/components/View_Component_Gestion_Gerencias'

import ComponentReporteCalendario from '../components/Component_Reporte_Calendario.vue'
import ComponentSolicitudesNoAprobadas from '@/components/Component_Solicitudes_No_Aprobadas'
import ViewEmpleadoSinNacimiento from '@/views/View_Empleado_Sin_Nacimiento'
import ViewMisContratos from '@/views/View_Mis_Contratos'
import ViewMisDocumentosFirmar from '@/views/View_Mis_Documentos_Firmar'
import ViewGestionCursos from '@/views/View_Gestion_Cursos'
import ViewListaCursos from '@/views/View_Cursos_Virtuales'
import ViewListaCursosClases from '@/views/View_Cursos_Virtuales_Clases'
import ViewListaCursosVideo from '@/views/View_Cursos_Virtuales_Video'
import ViewGestionCursosEditar from '@/views/View_Gestion_Cursos_Editar'
import ViewGestionClasesEditar from '@/views/View_Gestion_Clases_Editar'
import ViewReporteCursosVirtuales from '@/views/View_Reporte_Cursos_Virtuales'
import viewDiasFestivos                   from '@/views/View_Dias_Festivos'
import ViewReporteCursoTerminadoAlumno from '@/views/View_Reporte_Curso_Terminado_Alumno'

import ViewReporteContratos from '@/views/View_Reporte_Contratos'
import ViewReporteDocumentosFirmar from '@/views/View_Reporte_Documentos_Firmar'
import ViewDocumentosFirmar from '@/views/View_Documentos_Firmar'
import ViewAdministradorNoticias from '@/views/View_Administrador_Noticias'

import Notifications from 'vue-notification'
import { mixin as clickaway } from 'vue-clickaway';
Vue.use(infiniteScroll)
Vue.use(Router)
Vue.use(VueAxios, axios)

// Vue.use(require('@websanova/vue-upload'))
import VueUpload     from '@websanova/vue-upload';
import VueUploadHttp from '@websanova/vue-upload/dist/drivers/http/axios.esm.js';
import ViewGestionSalasReuniones from '../views/View_Gestion_Salas_Reuniones'
import ViewReuniones from '../views/View_Reuniones'
import ViewReunionesEditar from '../views/View_Reuniones_Editar'
import ViewReunionesVistaDetallada from '../views/View_Reunion_Vista_Detallada'
import { verificarAccesoEditar, verificarAccesoEsAsistente } from './guards'
Vue.use(VueUpload, {
  http: VueUploadHttp
});

Vue.use(Notifications)
Vue.axios.defaults.baseURL = process.env.API_ROUTE
Vue.mixin(clickaway)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'admin',
      component: adminView
    },
    {
      path: '/vacaciones',
      name: 'vacaciones',
      component: vacacionesView
    },
    {
      path: '/vacaciones-equipo',
      name: 'vacaciones-equipo',
      component: vacacionesEquipoView
    },
    {
      path: '/vacaciones-excepciones',
      name: 'vacaciones-excepciones',
      component: vacacionesExcepcionView
    },
    {
      path: '/vacaciones-reportes/:tipo',
      name: 'vacaciones-reportes',
      component: vacacionesReportesView,
      props: true
    },
    {
      path: '/funciones',
      name: 'mis-funciones',
      component: misFuncionesView
    },
    {
      path: '/datospersonales',
      name: 'mis-datos',
      component: misDatosView
    },
    {
      path: '/boletines',
      name: 'boletines',
      component: boletinesMensualesView
    },
    {
      path: '/dias-festivos',
      name: 'dias-festivos',
      component: viewDiasFestivos
    },
    {
      path: '/boletas',
      name: 'mis-boletas',
      component: misBoletasView
    },
    {
      path: '/boletas-transferidas',
      name: 'boletas-transferidas',
      component: boletasTransferidasView
    },
    {
      path: '/boletas-reporte',
      name: 'boletas-reporte',
      component: boletasReporteView
    },
    {
      path: '/vacaciones-reporte-excel',
      name: 'vacaciones-reporte-excel',
      component: ViewReporteVacaciones
    },
    {
      path: '/boletas-pendientes-generar',
      name: 'boletas-pendientes-generar',
      component: boletasPendientesGenerarView
    },
    {
      path: '/permisos',
      name: 'permisos',
      component: misPermisosView
    },
    {
      path: '/permisos-equipo',
      name: 'permisos-equipo',
      component: permisosEquipoView
    },
    {
      path: '/permisos-excepciones',
      name: 'permisos-excepciones',
      component: permisosExcepcionView
    },
    {
      path: '/permisos-aprobar-rrhh',
      name: 'permisos-aprobar-rrhh',
      component: permisosPorAprobarRRHHView
    },
    {
      path: '/permisos-reportes/:tipo',
      name: 'permisos-reportes',
      component: permisosReportesView,
      props: true
    },
    {
      path: '/contratos-equipo',
      name: 'contratos-equipo',
      component: contratosEquipoView,
      props: true
    },
    {
      path: '/contratos-gestion',
      name: 'contratos-gestion',
      component: contratosGestionView,
      props: true
    },
    {
      path: '/gestion/empleado',
      name: 'gestion-empleado',
      component: ViewGestionEmpleados
    },
    {
      path: '/gestion/documentos-importantes',
      name: 'gestion-documentos-importantes',
      component: ViewGestionDocumentosImportantes
    },
    {
      path: '/documentos-importantes',
      name: 'documentos-importantes',
      component: ViewDocumentosImportantes
    },
    {
      path: '/boletas-carga-manual',
      name: 'boletas-carga-manual',
      component: ViewBoletasCargaManual
    },
    {
      path: '/boletas-tipo',
      name: 'boletas-tipo',
      component: ViewBoletasTipo
    },
    {
      path: '/gestion/links-importantes',
      name: 'gestion-links-importantes',
      component: ViewGestionLinksImportantes
    },
    {
      path: '/links-importantes',
      name: 'links-importantes',
      component: ViewLinksImportantes
    },
    {
      path: '/auditoria',
      name: 'auditoria',
      component: ViewAuditoria
    },
    {
      path: '/horas-extras-reporte',
      name: 'horas-extras-reporte',
      component: ViewHorasExtras
    },
    {
      path: '/gestion-delegaciones-rrhh',
      name: 'gestion-delegaciones-rrhh',
      component: ComponentGestionDelegaciones
    },
    {
      path: '/gestion-delegaciones-jefes',
      name: 'gestion-delegaciones-jefes',
      component: ComponentAsignarDelegaciones
    },
    {
      path: '/solicitudes-no-aprobadas',
      name: 'solicitudes-no-aprobadas',
      component: ComponentSolicitudesNoAprobadas
    },
    {
      path:'/administrador-funciones',
      name:'administrador-funciones',
      component: ComponentAdministradorFunciones
    },
    {
      path:'/administrador-noticias',
      name:'administrador-noticias',
      component: ViewAdministradorNoticias
    },
    {
      path: '/reporte-calendario',
      name: 'reporte-calendario',
      component: ComponentReporteCalendario
    },
    {
      path: '/cumpleanios',
      name: 'cumpleanios',
      component: ViewCumpleanios
    },
    {
      path: '/empleado-sin-nacimiento',
      name: 'empleado-sin-nacimiento',
      component: ViewEmpleadoSinNacimiento
    },
    {
      path: '/gestion-areas',
      name: 'gestion-areas',
      component: ViewComponentGestionAreas
    },
    {
      path: '/gestion-gerencias',
      name: 'gestion-gerencias',
      component: ViewComponentGestionGerencias
    },
    {
      path: '/contratos-carga-manual',
      name: 'contratos-carga-manual',
      component: ViewContratosCargaManual
    },
    {
      path: '/mis-contratos',
      name: 'mis-contratos',
      component: ViewMisContratos
    },
    {
      path: '/reporte-contratos',
      name: 'reporte-contratos',
      component: ViewReporteContratos
    },
    {
      path: '/gestion-documentos-firmar',
      name: 'gestion-documentos-firmar',
      component: ViewDocumentosFirmar
    },
    {
      path: '/reporte-documentos-firmar',
      name: 'reporte-documentos-firmar',
      component: ViewReporteDocumentosFirmar
    },
    {
      path: '/mis-documentos-firmar',
      name: 'mis-documentos-firmar',
      component: ViewMisDocumentosFirmar
    },
    {
      path: '/gestion-cursos',
      name: 'gestion-cursos',
      component: ViewGestionCursos
    },
    {
      path: '/gestion-cursos/:id',
      name: 'gestion-cursos-editar',
      component: ViewGestionCursosEditar
    },
    {
      path: '/gestion-cursos/:id/gestion-clases/:idClase',
      name: 'gestion-clases-editar',
      component: ViewGestionClasesEditar
    },
    {
      path: '/mis-cursos',
      name: 'mis-cursos',
      component: ViewListaCursos
    },
    {
      path: '/mis-cursos/:idCurso/clases',
      name: 'mis-clases',
      component: ViewListaCursosClases
    },
    {
      path: '/mis-cursos/:idCurso/clases/:idClase',
      name: 'clase-video',
      component: ViewListaCursosVideo
    },
    {
      path: '/reporte-cursos',
      name: 'reporte-cursos',
      component: ViewReporteCursosVirtuales
    },
    {
      path: '/reporte-cursos-terminados-alumnos',
      name: 'reporte-cursos-terminados-alumnos',
      component: ViewReporteCursoTerminadoAlumno
    },
    {
      path: '/gestion-sala-reuniones',
      name: 'gestion-sala-reuniones',
      component: ViewGestionSalasReuniones
    },
    {
      path: '/mis-reuniones',
      name: 'mis-reuniones',
      component: ViewReuniones
    },
    {
      path: '/gestion-reuniones/:idReunion',
      name: 'gestion-reuniones-editar',
      component: ViewReunionesEditar,
      beforeEnter: verificarAccesoEditar
    },
    {
      path: '/reunion-vista-detallada/:idReunion',
      name: 'reunion-vista-detallada',
      component: ViewReunionesVistaDetallada,
      beforeEnter: verificarAccesoEsAsistente
    }
  ]
})

router.beforeEach((to, from, next) => {
  store.dispatch('setSidebarMobile', false)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/admin.js